<template>
  <input
    type="text"
    inputmode="decimal"
    :value="rawInput"
    @input="handleInput"
    :disabled="disabled"
    :placeholder="placeholder"
    :class="inputClass"
  />
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: { type: [Number, String], default: '' },
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: 'Bijv. 2.5' },
  inputClass: { type: [String, Array, Object], default: '' }
})

const emit = defineEmits(['update:modelValue'])

const rawInput = ref(
  props.modelValue !== '' && props.modelValue != null ? String(props.modelValue) : ''
)

// Sync when parent changes value externally
watch(
  () => props.modelValue,
  newVal => {
    const normalized = newVal !== '' && newVal != null ? String(newVal) : ''
    if (parseFloat(rawInput.value.replace(',', '.')) !== parseFloat(normalized)) {
      rawInput.value = normalized
    }
  }
)

const handleInput = event => {
  let raw = event.target.value
  // Allow only digits, one dot or comma, max 1 decimal place
  raw = raw.replace(/[^0-9.,]/g, '')
  const parts = raw.split(/[.,]/)
  if (parts.length > 2) {
    raw = parts[0] + '.' + parts[1]
  }
  const dotIndex = raw.search(/[.,]/)
  if (dotIndex !== -1 && raw.length - dotIndex - 1 > 1) {
    raw = raw.substring(0, dotIndex + 2)
  }

  rawInput.value = raw

  const normalized = raw.replace(',', '.')
  if (normalized === '' || normalized === '.') {
    emit('update:modelValue', '')
    return
  }

  const value = parseFloat(normalized)
  if (!isNaN(value)) {
    const clamped = Math.min(5, Math.max(0, value))
    emit('update:modelValue', clamped)
    if (clamped !== value) {
      rawInput.value = String(clamped)
    }
  }
}
</script>
